















import Vue from "vue";
import Component from "vue-class-component";
import homeContent from "@/content/home.json";

@Component({
  components: {},
})
export default class UnitSummary extends Vue {
  private header = homeContent.unitSummary.header;
  private subtitle = homeContent.unitSummary.subtitle;
  private text = homeContent.unitSummary.text;
}
